import { render, staticRenderFns } from "./approve-adjustment.vue?vue&type=template&id=6af4a7c7"
import script from "./approve-adjustment.vue?vue&type=script&lang=js"
export * from "./approve-adjustment.vue?vue&type=script&lang=js"
import style0 from "./approve-adjustment.vue?vue&type=style&index=0&id=6af4a7c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports